$(document).ready(function() {
    $(".lp-tr--learn-more-btn").click(function() {
        $('.lp-tr--scroll-to-learn').fadeIn('slow');
        
        const sectionHeight = $('.lp-tr--why-kids-love-np-section').outerHeight();
        
        const sectionOffsetTop = $('.lp-tr--why-kids-love-np-section').offset().top;

        $(window).scroll(function() {
            let scrollTopj = $(window).scrollTop();
            let scrollPoint = sectionOffsetTop + sectionHeight;
            
            console.log('ScrollTop:', Math.floor(scrollTopj), 'ScrollPoint:', Math.floor(scrollPoint));
            
            if (scrollTopj >= scrollPoint) {
                $('.lp-tr--scroll-to-learn').fadeOut('fast');
            } 
        });
    });

    const priceNumEl = $('.overall-price .price-num');
    const priceOffEl = $('.overall-price .price-off'); 
    const priceCompareEl = $('.compare-price'); 
    const priceSavedEl = $('.saved-price'); 
    const defaultPriceEl = $('.packs input[type="radio"]:checked').attr('data-tick-price')

    const addToCart = $('#proceed')
    const currency = addToCart.attr('data-currency')
    priceNumEl.text(defaultPriceEl)

    $('.packs input[type="radio"]').change(function() {
        const currentPrice = $(this).attr('data-tick-price')
        const currentId = $(this).attr('data-tick-id')
        const currentPercentOff = $(this).attr('data-percent-off')
        const currentCompare= $(this).attr('data-compare-price')
        const currentSaved = $(this).attr('data-saved-price')
        if ($(this).val() == "1") {
          $('.hide-pack-price').hide();
        } else {
          $('.hide-pack-price').show();
        }
        priceNumEl.text(currentPrice)
        priceOffEl.text(currentPercentOff)
        priceCompareEl.text(currentCompare)
        priceSavedEl.text(currentSaved)
        addToCart.attr('href', `/cart/${currentId}:1?currency=${currency}`)
    })



});

